export default "__VITE_ASSET__BKlDMvhM__"